// @ts-ignore
import i18next from "jsdc-dui/dist/i18n/config";

// 直接添加自訂翻譯資源到已初始化的 i18next 實例
i18next.addResourceBundle(
  "zh-TW",
  "translation",
  {
    aboutWalkContent: `溯矽城之源：新竹頭前溪畔的產業聚落、晶片地景與基礎設施

新竹常被視為台灣晶片產業的發源地，但晶片從來不只是無塵室中的技術，而是由水、土地、族群、移工、學校、企業與政策共同編織的城市生命網絡。本次走讀將沿著頭前溪兩岸展開旅程，從山林、水圳到科學園區，從原民文化到移工聚落，看見半導體產業如何在城市的歷史土壤中生長與扎根。

在上游的尖石泰雅族部落，我們探索頭前溪所孕育的水文化，理解水作為生命、信仰與公共資源時所牽動的協商與衝突；而位於上坪的攔河堰則見證了生態自然與工業發展間長期存在的張力。沿溪而下，來到曾以林業、茶葉與跨洋貿易繁盛一時的北埔姜阿新洋樓，看見新竹早期的商業智慧如何在地景與產業中累積。進入竹東資源莊，則能觸碰戰後社會住宅、移民與產業轉型所留下的深刻記憶。

進入都市腹地，走讀將引領我們回到新竹半導體的制度與基礎設施之源：從日本殖民時期興建的能源水圳與辦公廳舍，到戰後串連產業與學術的工研院，再到培育無數半導體人才的陽明交大。這些空間與制度奠定了科學城的基礎，使新竹科學園區得以在 1980 年代成為國家級科技特區，整合水資源調度、土地治理、交通建設與技術政策，孕育今日全球半導體的重要樞紐。

然而，晶片並非僅由白領工程師共同打造。在湖口，我們看見移工聚落對半導體供應鏈的關鍵貢獻——從塑膠、螺絲到機構件，移工以勞力與技術支撐園區外圍的傳統產業，成為晶片生態系不可缺少的底層能量。在寶山大崎，則能看見客家聚落在先進製程與產業擴張下所面臨的存續與空間困境。

晶片不是純科技，而是一座城市的故事。
跟著我們走入新竹，走入台灣半導體半世紀的生命史。`,
  },
  true,
  true,
);

i18next.addResourceBundle(
  "en",
  "translation",
  {
    aboutWalkContent: `River, Chip, City: The Historical Landscape and Infrastructure of Silicon Urbanism in Hsinchu
    
Hsinchu is often regarded as the birthplace of Taiwan’s chip industry, yet a chip is far more than the technology inside a cleanroom. It is a living network woven from water, land, local communities, migrant labor, schools, industries, and public policy.
This walking tour traces both banks of the Touqian River, moving from forests and irrigation canals to the Science Park, from Indigenous cultures to migrant-worker settlements, revealing how the semiconductor industry took root and flourished in the city’s historical soil.

Upstream, in the Atayal communities of Jianshi, we explore the river’s water culture—understanding water as life, as belief, and as a contested public resource shaped by negotiation and conflict. At Shangping Weir, we witness the longstanding tensions between ecological landscapes and industrial development.
Following the river downstream, we arrive at the Chiang A-Hsin Mansion in Beipu, once a thriving center of forestry, tea production, and transoceanic trade, where we see how early commercial ingenuity shaped Hsinchu’s landscape and industries. Entering Zhudong Resource Village, we encounter memories of postwar social housing, migration, and industrial transformation.

As we move into the metropolitan core, the tour guides us back to the institutional and infrastructural origins of Hsinchu’s semiconductor sector: the energy irrigation offices built during Japanese colonial rule, the Industrial Technology Research Institute (ITRI) that bridged industry and academia in the postwar era, and National Yang Ming Chiao Tung University, which has trained generations of semiconductor engineers.
These spaces and institutions laid the foundation for the Science City, enabling the Hsinchu Science Park to become a national techno-zone in the 1980s—integrating water management, land governance, transportation, and technology policy to shape today’s global semiconductor powerhouse.

But chips are not built by white-collar engineers alone.
In Hukou, we see migrant-worker communities whose labor sustains the local semiconductor supply chain—from plastics and screws to mechanical components. Migrant workers provide the skills and labor that support traditional industries surrounding Hsinchu, forming an essential yet often overlooked layer of the chip ecosystem.
In Baoshan’s Daqi Village, we confront the challenges that Hakka communities face as advanced semiconductor facilities expand into their living spaces.

A chip is not merely technology—it is the story of a city.
Join us as we walk into Hsinchu, and into half a century of Taiwan’s semiconductor life history.`,
  },
  true,
  true,
);
